import { useState, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import {
  getSessions_vw,
  deleteSessions,
} from "../../../actions/manageSessionsAction";
import { Link } from "react-router-dom";
import AttendeesTableModal from "./attendees_table_modal/attendees_table_modal";
import confirm from "../../../components/ConfirmModal/confirm";
import trashIcon from "../../../assets/icons/Trash_Icon_clear.png";
import infoIcon from "../../../assets/icons/info-icon-clear.png";
import alert from "../../../components/AlertModal/alertModal";
import styles from "./session_tables.module.css";
import Table from "../../../components/Table";
import moment from "moment/moment";
import {
  closeLoading,
  openLoading,
} from "../../../components/loadingModal/loading";

const PastSessionsTable = (props) => {
  const { user, sessions, getSessions_vw, deleteSessions } = props;
  const [selectedSession, setSelectedSession] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [showTable, setShowTable] = useState(false);

  const getInitialData = async () => {
    try {
      openLoading();
      await getSessions_vw({ active: false });
    } catch (err) {
      alert("ERROR", err.message);
    } finally {
      closeLoading();
    }
  };

  useEffect(() => {
    getInitialData();
  }, []);

  // useEffect(() => {
  //   openLoading();
  //   const timer1 = setTimeout(() => {
  //     closeLoading();
  //   }, 3000);

  //   return () => clearTimeout(timer1);
  // }, []);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowTable(true);
  //   }, 1000);

  //   return () => clearTimeout(timer);
  // }, []);

  const handleOpen = (row) => {
    setSelectedSession(row);
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
    setSelectedSession(null);
  };
  const handleDelete = async (row) => {
    const response = await confirm(
      "Confirm",
      "Are you sure you want to delete this session?",
    );
    if (!response) return;
    try {
      await deleteSessions(row.idMultiplayer);
      alert("Successfully", "Session has been deleted");
      await getSessions_vw({ active: false });
    } catch (error) {
      alert("ERROR", "Session could not be deleted");
    }
  };
  const role = user.role;

  const columns = useMemo(
    () => [
      {
        id: "date",
        Header: () => <div className="table-title">DATE</div>,
        accessorFn: (row) => moment(row.dateSession).format("MMM DD, YYYY"),
        header: "Date",
        enableColumnFilter: false,
        enableSorting: false,
        grow: false,
        size: 80,
      },
      {
        id: "time",
        Header: () => <div className="table-title">START TIME</div>,
        accessorFn: (row) => moment(row.dateSession).format("hh:mm A"),
        header: "Start Time",
        enableColumnFilter: false,
        enableSorting: false,
        grow: false,
        size: 20,
      },
      {
        id: "module",
        header: "Product",
        Header: () => <div className="table-title">MODULE</div>,
        accessorFn: (row) => row.moduleName,
        enableColumnFilter: false,
        enableSorting: false,
        grow: false,
        size: 100,
      },
      {
        id: "title",
        header: "Title",
        Header: () => <div className="table-title">TITLE</div>,
        accessorFn: (row) => (
          <Link className="link-clear" to={`previous/${row.idMultiplayer}`}>
            {row.title}
          </Link>
        ),
        enableColumnFilter: false,
        enableSorting: false,
        size: 180,
        grow: true,
      },
      {
        header: "Session Code",
        accessorKey: "sessionCode",
        Header: () => <div className="table-title">ROOM NUMBER</div>,
        enableColumnFilter: false,
        enableSorting: false,
        grow: false,
        size: 20,
      },
      {
        id: "attendees",
        header: "Attendees",
        Header: () => <div className="table-title">ATTENDEES</div>,
        accessorFn: (row) => (
          <div className="actions-container">
            <div>{row.users.length}</div>
            <div className={styles.rowInfoContainer}>
              <img
                src={infoIcon}
                alt="Information about attenders"
                className={styles.infoIcon}
                onClick={() => handleOpen(row)}
              />
            </div>
          </div>
        ),
        enableColumnFilter: false,
        enableSorting: false,
        grow: false,
        size: 20,
      },
      {
        id: "actions",
        header: "Actions",
        Header: () => <div className="table-title">ACTIONS</div>,
        accessorFn: (row) => (
          <div className="actions-container">
            <img
              src={trashIcon}
              alt="Delete Session"
              className={styles.actionIcon}
              onClick={() => handleDelete(row)}
            />
          </div>
        ),
        enableHiding: true,
        enableColumnFilter: false,
        enableSorting: false,
        grow: false,
        size: 20,
      },
    ],
    [],
  );

  return (
    <div className={styles.tableWrapper}>
      <div className="table-container">
        <Table
          data={sessions}
          height="clamp(100px, 45vh, 800px)"
          columns={columns}
          hiddenColumns={{ actions: role !== "Learner" }}
          textColor="#b2b6fe"
        />
      </div>
      {isOpen && selectedSession && (
        <AttendeesTableModal
          users={selectedSession.users}
          close={handleClose}
          title="ATTENDEES"
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    sessions: state.manageSessionReducer.sessions_vw,
    user: state.usersReducer.userLogged,
  };
};

export default connect(mapStateToProps, { getSessions_vw, deleteSessions })(
  PastSessionsTable,
);
